import React, { useState } from "react";
import { useDispatch } from "react-redux";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { approvsubmitedMilestoneWork } from "../../../../../../../../redux/project/action";
import DownloadButton from "../../../../../../../Common/FilesRelevent/DownloadButton";
import DisplayFileProper from "../../../../../../../Common/FilesRelevent/DisplayFileProper";
import { navigateToNextTab } from "../../../../../../../Common/FewCommonMethods";
import { decodeHtml } from "../../../../../../../../assests/extention/commonfunction";

export default function ProjectApproveSubmission({
  index,
  setSWModel,
  milestonedata,
  posts,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showTextarea, setShowTextarea] = useState(false);

  const Requestrevision = (id) => {
    const data = {
      milestone_submition_id: id,
      type: 2,
      message: message,
      status: 2,
    };
    dispatch(approvsubmitedMilestoneWork(data, setLoading));
  };

  const ApproveSubmission = (id) => {
    const data = {
      milestone_submition_id: id,
      type: 2,
      // message: message,
      status: 1,
    };
    dispatch(approvsubmitedMilestoneWork(data, setLoading));
  };

  const getFileNameFromUrl = (url) => {
  const decodedUrl = decodeURIComponent(url);
  const fileWithExt = decodedUrl.split('/').pop().split('?')[0];
  return fileWithExt.split('_').slice(1).join('_');
};
  return (
    <>
      <div className="modal-dialog mt-0">
        <div className="modal-content">
          <button onClick={() => setSWModel(false)} className="btn close-button mb-3">
            <img
              src={`${CloudStorage.cloudurl}//Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <div className="modal-body">
            <p className="breadcrumbs" onClick={() => { posts?.is_bxp == "1" ? navigateToNextTab(`packageddetails/${posts?.bxp_id}`) : navigateToNextTab(`projectdetails/${posts.id}`) }}>
              <a >Project name &gt; </a> {decodeHtml(posts?.title)}
            </p>
            <div className="modal-row">
              <div className="submission-sec">
                <h6>Submission</h6>
                <h4>
                  {index}. {milestonedata?.title}
                </h4>
              </div>

              {Array.isArray(milestonedata?.submition) &&
                milestonedata.submition[0] && (
                  <>
                    <div>
                      <h6>Description</h6>
                      <p>{milestonedata.submition[0]?.message}</p>
                      {milestonedata.submition[0]?.revision && (
                        <>
                          <h6 style={{ paddingTop: '30px' }}>Revision</h6>
                          <p>{milestonedata.submition[0]?.revision}</p>
                        </>
                      )}
                    </div>

                    { }
                    <div>
                      <h6>Attachments</h6>
                      {Array.isArray(milestonedata.submition[0]?.files) &&
                        milestonedata.submition[0].files.map((file, fileIndex) => (
                          <div key={fileIndex} className="display-img mt-2 display-wrapper-img">
                            <span>File {fileIndex + 1}</span>
                            <div className="display-img">
                              <DisplayFileProper item={file} />
                              <DownloadButton file={file} />
                            </div>
                          </div>
                        ))}
                    </div>

                    {milestonedata.submition[0].status == 0 && (
                      <>
                        {posts?.is_mine == 1 && (
                          <>
                            <div className="d-flex justify-content-between align-items-center mt-4">
                              <button className="buttons border-button"
                                onClick={() => {
                                  setShowTextarea(true);
                                }}
                              >
                                Request revision
                              </button>
                              <button className="buttons background-button"
                                onClick={() => {
                                  setShowTextarea(false);
                                  ApproveSubmission(
                                    milestonedata.submition[0]?.id,
                                  );
                                }}
                              >
                                Approve Submission
                              </button>
                            </div>
                            {showTextarea && (
                              <div className="d-flex flex-column  revision-btn ">
                                <textarea
                                  placeholder="Enter revision reason"
                                  value={message}
                                  className="form-control"
                                  onChange={(e) => setMessage(e.target.value)}
                                />
                                <button className="buttons background-button "
                                  onClick={() => {
                                    Requestrevision(
                                      milestonedata.submition[0]?.id,
                                    );
                                  }}
                                >
                                  Submit Revision Request
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
